import { PremadeMessage } from './premade-message.model';
import { PremadeMessageInterface } from './premade-message.interface';

export class PremadeMessageFactory {

    static empty(): PremadeMessage {
        return new PremadeMessage('', '', '', '', '', '', undefined, undefined, '');
    }

    static fromObject(raw: PremadeMessageInterface | any): PremadeMessage {
        if (!raw) {
            return PremadeMessageFactory.empty();
        }
        if (raw.success === false) {
            throw new Error(raw.message);
        }
        return new PremadeMessage(
            raw.id || '',
            // entries created before the name field existed fall back to their subject
            raw.name || raw.title || '',
            raw.description || '',
            raw.title || '',
            raw.text || '',
            raw.user || '',
            raw.date && raw.date._seconds ? new Date(raw.date._seconds * 1000) : raw.date,
            raw.updateDate && raw.updateDate._seconds ? new Date(raw.updateDate._seconds * 1000) : raw.updateDate,
            raw.textDelta || '',
        );
    }
}



// WEBPACK FOOTER //
// ./src/app/settings/premade-messages/shared/premade-message.factory.ts